export const PAN_REGEX = /^[A-Z]{3}[A,B,C,F,G,H,L,J,P,T]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{3}[A,B,C,F,G,H,L,J,P,T]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const GSTIN_USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9._-]{7,14}$/;
export const GSTIN_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/;
export const TN_REGX = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
export const TRACE_USER_ID_REGEX = /^[\w!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]{6,11}$/;
export const TRACE_PASSWORD_REGEX = 
  /^(?=.*[A-Z])(?=.*\d)[\w!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]{8,15}$/;


